import { useEffect, useState } from "react";
import { KeyRound, UserPlus, Users } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Card, Field, inputCls } from "./fields";

export default function AccountTab() {
  const [admins, setAdmins] = useState(null);
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [cf, setCf] = useState("");

  const load = async () => {
    try {
      const { data } = await api.get("/admin/users");
      setAdmins(data);
    } catch (e) {
      toast.error(apiError(e));
    }
  };
  useEffect(() => {
    load();
  }, []);

  const addAdmin = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) return toast.error("كلمة المرور يجب أن تكون 8 أحرف على الأقل");
    try {
      await api.post("/admin/users", { email, password: pwd });
      toast.success("تمت إضافة المشرف بنجاح");
      setEmail("");
      setPwd("");
      load();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const changePw = async (e) => {
    e.preventDefault();
    if (nw.length < 8) return toast.error("كلمة المرور الجديدة يجب أن تكون 8 أحرف على الأقل");
    if (nw !== cf) return toast.error("تأكيد كلمة المرور غير مطابق");
    try {
      await api.post("/admin/change-password", { current_password: cur, new_password: nw });
      toast.success("تم تغيير كلمة المرور بنجاح");
      setCur("");
      setNw("");
      setCf("");
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  return (
    <div className="grid gap-6 lg:grid-cols-2" data-testid="admin-account-tab">
      <Card title="تغيير كلمة المرور" testid="admin-card-change-password">
        <form onSubmit={changePw} className="space-y-4">
          <Field label="كلمة المرور الحالية">
            <input
              type="password"
              dir="ltr"
              className={`${inputCls} text-left`}
              data-testid="admin-change-current"
              value={cur}
              onChange={(e) => setCur(e.target.value)}
            />
          </Field>
          <Field label="كلمة المرور الجديدة (8 أحرف على الأقل)">
            <input
              type="password"
              dir="ltr"
              className={`${inputCls} text-left`}
              data-testid="admin-change-new"
              value={nw}
              onChange={(e) => setNw(e.target.value)}
            />
          </Field>
          <Field label="تأكيد كلمة المرور الجديدة">
            <input
              type="password"
              dir="ltr"
              className={`${inputCls} text-left`}
              data-testid="admin-change-confirm"
              value={cf}
              onChange={(e) => setCf(e.target.value)}
            />
          </Field>
          <button
            type="submit"
            data-testid="admin-change-submit"
            className="inline-flex items-center gap-2 rounded-full bg-forest-900 px-6 py-3 text-sm font-bold text-cream transition hover:bg-forest-800"
          >
            <KeyRound className="h-4 w-4" />
            تغيير كلمة المرور
          </button>
        </form>
      </Card>

      <div className="space-y-6">
        <Card title="إضافة مشرف جديد" testid="admin-card-add-admin">
          <form onSubmit={addAdmin} className="space-y-4">
            <Field label="البريد الإلكتروني">
              <input
                type="email"
                dir="ltr"
                className={`${inputCls} text-left`}
                placeholder="new.admin@example.com"
                data-testid="admin-add-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Field>
            <Field label="كلمة المرور (8 أحرف على الأقل)">
              <input
                type="password"
                dir="ltr"
                className={`${inputCls} text-left`}
                data-testid="admin-add-password"
                value={pwd}
                onChange={(e) => setPwd(e.target.value)}
              />
            </Field>
            <button
              type="submit"
              data-testid="admin-add-submit"
              className="inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-bold text-forest-950 transition hover:bg-gold-light"
            >
              <UserPlus className="h-4 w-4" />
              إضافة المشرف
            </button>
          </form>
        </Card>

        <Card title="المشرفون الحاليون" testid="admin-card-admins-list">
          {admins === null && <p className="text-sm text-moss">جارٍ التحميل…</p>}
          {admins && (
            <ul className="space-y-3" data-testid="admin-users-list">
              {admins.map((a, i) => (
                <li
                  key={a.email}
                  className="flex items-center justify-between rounded-xl border border-line bg-white px-4 py-3"
                  data-testid={`admin-user-${i}`}
                >
                  <span className="flex items-center gap-2 text-sm text-ink">
                    <Users className="h-4 w-4 text-gold-dark" />
                    <span dir="ltr">{a.email}</span>
                  </span>
                  <span className="text-xs text-moss">
                    {a.created_at ? new Date(a.created_at).toLocaleDateString("ar") : ""}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </Card>
      </div>
    </div>
  );
}
